<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol sm="3" md="3" xs="12" xl="2">
        <BaseInput
          :options="nameStationInput.options"
          :data="nameStationInput.data"
          :listener="nameStationInput.listener"
        />
      </CCol>
      <CCol sm="3" md="3" xs="12" xl="2">
        <BaseSelect :options="typeSystemSelect.options" :data="typeSystemSelect.data"
                    ref="typeSystemSelect"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/administrator/contractor-information/add.html')">
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listStationSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{item}">
            <td>{{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}</td>
          </template>
          <template #typeSystem="{item}">
            <td>
              <span class="badge badge-secondary" v-if="item.typeSystem == 0"> Truyền thanh cơ sở</span>
              <span class="badge badge-secondary" v-else> Bản tin điện tử</span>
            </td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Cập nhật'"
                  @click="$router.push(`/administrator/contractor-information/${item.id}/update.html`)">
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click=" setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2"
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {LOCATION_CODE_NAME, USER_NAME} from "@/constant";

export default {
  name: "AudioStationFileList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/contract_information/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "nhà thầu",
          that.actionData.model.contractorInformationName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.contractorInformationId
        };
      },
      successCallback: function () {
        that.actionData.model.listStationSelectedId = [];
        that.showSuccessMsg({message: "Xóa nhà thầu thành công"});
        that.loadDataMainTable();
      }
    });
    return {
      loading: {value: false},
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          contractorInformationId: null,
          contractorInformationName: null,
        }
      },
      nameStationInput: {
        options: {
          placeholder: "Tên cấu hình",
          label: 'Tên cấu hình'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      typeSystemSelect: {
        options: {
          filter: false,
          label: "Hệ thống",
          selectAllText: "Tất cả hệ thống",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "typeSystem",
          model: null,
          items: [
            {key: "0", value: "Truyền thanh cơ sở"},
            {key: "1", value: "Bản tin điện tử"}
          ],
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      mainTable: {
        options: {
          noPaging: true,
          fields: [
            {key: "index", label: "STT"},
            {key: "createDate", label: "Ngày tạo"},
            {key: "name", label: "Tên cấu hình"},
            {key: "urlSendToStation", label: "API gửi lịch"},
            {key: "urlAddFile", label: "API thêm bản tin"},
            {key: "urlDeleteFile", label: "API xóa bản tin"},
            {key: "typeSystem", label: "Loại hệ thống"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["createDate", "index", "typeSystem", "action"],
        },
        dataSource: {
          url: "/contract_information/getList",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          resultListAttrName: "data"
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, contractorInformationId, contractorInformationName) {
      var actionData = this.actionData.model;
      actionData.contractorInformationId = contractorInformationId || null;
      actionData.contractorInformationName = contractorInformationName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    setupSelectMoreAction: function (actionTypeKey) {
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {},
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
